import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SGSSectionTitle.module.scss';

type Props = {
    title: string;
};

const SGSSectionTitle: React.FC<Props> = ({ title }) => {
    const { t } = useTranslation();
    return <span className={styles.root}>{t(title)}</span>;
};

export default SGSSectionTitle;
